export default __webpack_public_path__ + "static/shadow-dont-1a588aa91242725d8c7290284a553e26de95914570fc96ee66660286845404f5.png";